export default {
  // Where to submit to publish after user authenticates
  publishUrl: null,

  // Where to submit to link user to new campaign
  linkUserUrl: null,

  // Where to redirect to after publishing
  redirectUrl: null,

  // URL to submit for one-click moderation after publishing
  oneClickModerationUrl: null,

  // Text to display on the form, organised by field
  content: {},

  // Extra parameters we should submit with the form
  extraParameters: {},

  // If the user can choose to associate the event with a partnership, the list of options
  partnershipOptions: [],

  // Flag indicating if the "campaign awaiting approval" modal should be displayed
  displayAwaitingApprovalModal: false,
  // This 2nd flag is used when the campaign is awaiting approval but we don't want to display the modal
  // because the user can automatically moderate the campaign. In that case, once the user chooses not to
  // moderate, we can display the awaiting approval modal
  campaignAwaitingApproval: false,

  //// Sign in / sign up properties
  authenticationModalData: {
    // SSO options
    enableFacebookLogin: false,
    facebookLoginUrl: null,
    enableGoogleLogin: false,
    googleLoginUrl: null,

    askForCountry: null,
    countryData: null,
    askForPostcode: null,
    phoneNumberMandatory: null,

    emailOptInTypeData: null,

    newAccountDisclaimer: null,

    // EU Data processing consent
    showEuDataProcessingConsent: false,
    euDataProcessingConsentData: null,

    termsOfServiceData: null,

    organisationId: null,
    additionalFieldConfigs: []
  },

  // Flag indicating if the user authentication modal should be displayed
  displayAuthenticationModal: false,

  // Flag indicating if the modal notifying user that account creation is pending
  // email confirmation should be displayed
  displayUserAccountCreationAwaitingEmailConfirmation: false,

  // Flag indicating if the MFA token verification modal should be displayed
  displayVerifyMfaTokenModal: false,

  // Flag indicating if the modal to collect missing user account info should be displayed
  displayMissingInfoModal: false,

  // Flag indicating if the modal to confirm that the campaign will be automatically
  // moderated should be displayed
  displayModerateOnPublishModal: false,

  // Error message for non recoverable error during sign up (e.g.: member is banned)
  nonRecoverableErrorOnSignup: null,

  // Email address of the user that's awaiting to be confirmed
  userEmailAddressAwaitingConfirmation: null,

  // Setup information for the MFA token verification modal
  mfaParameters: {
    userId: null,
    statusCheckPath: null,
    supportsSms: false,
    tokenHelpText: null,
    verifyTokenPath: null
  },

  // Setup information for the Missing Info modal
  missingInfoRequiredFields: []
}
